import React, { useState, useEffect, useRef } from 'react';
import { Button, Spin, message } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { Base } from '../../public/js/base';
import { Config } from '../../public/js/config';
import { ContextHandler } from '../../public/js/contextHandler';
import moment from 'moment';//日期格式化导包
import $ from 'jquery';
import { studentCheckLogin } from '../newMain/studentMain';
import { PrinterOutlined } from '@ant-design/icons';

import './studentJobDetail.css'
import StdApplyJobModal from './stdApplyJobModal';
import NewMessage from '../../component/newMessage/newMessage';

import submitApplication from '../../public/img/buttonImg/submitApplication.png';
import CompanyLogo from '../../public/img/company/companyLogo.png';

const StudentJobDetail = () => {
    const history = useHistory();
    const { jobId, flag } = useParams();
    const [jobPostModel, setJobPostModel] = useState({})
    const messageRef = useRef();
    const messageRefAssignd = useRef();
    const [isStdApplyJobModal, setIsStdApplyJobModal] = useState(false);
    const [jobApplId, setJobApplId] = useState('')
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchById(jobId)
    }, []);

    const searchById = (jobId) => {
        Base.callBackApi("studentJob/searchById", {'jobId': jobId}).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setJobPostModel(model);

                let jobDesc = model?.jobDesc?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobDesc").empty().append(jobDesc);
                let jobRequirement = model?.jobRequirement?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobRequirement").empty().append(jobRequirement);
                let companyProfile = model?.companyProfile?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#companyProfile").empty().append(companyProfile);

                if (flag === 'apply') {
                    apply()
                }
            } else {
                message.error(data.msg)
            }
        })
    }

    const errFrameShow = (msg, flag) => {
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        messageRefAssignd.current.setStatusFlag(flag)
    }

    const done = () => {
        history.replace("/student/studentApplyJobDetail/" + jobApplId)
    }

    const apply = () => {
        setIsStdApplyJobModal(true)
    }

    const stdApplyJobClose = (flag, jobApplId, applyFlag) => {
        if (flag) {
            setIsStdApplyJobModal(false);
            setJobApplId(jobApplId)
            if (applyFlag === 'apply') {
                errFrameShow("You've successfully applied to this position. Please wait for your module convener to approve your application to verify prerequisites.", true)
            } else if (applyFlag === 'draft') {
                errFrameShow("You have successfully saved your draft.", true)
            }
        } else {
            setIsStdApplyJobModal(false);
        }
    }



    const doneAssignd = () => {
        messageRefAssignd.current.setIsShow(false)
    }

    const generatePdf = (model) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        fetch(Config.apiDownloadServer + "studentJobDetailPdf/generatePdf", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    console.log(data);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "StudentJobDetail" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".pdf";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    return (
        <div id="container" className='websiteTemplate studentJobDetail'>
            <NewMessage ref={messageRefAssignd} done={doneAssignd} />
            <NewMessage ref={messageRef} done={done} />
            <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className="detailTitle">
                        Apply for {jobPostModel.jobTitle}
                    </div>
                    <div className="websiteSysButtonBox">
                        {(flag === 'view' || flag === 'apply' || flag === 'assigned') && jobPostModel.lastApplyDate >= moment().startOf('day').valueOf() &&
                            <div className='websiteSysButton' onClick={apply} ><img src={submitApplication} />Apply</div>
                        }
                    </div>
                </div>
                <div className="websiteSysContentBox">
                    <div className='detailPrintButtonTopBox'></div>
                    <Button className="websiteSysButton detailPrintButton" onClick={() => generatePdf(jobPostModel)} style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} type="primary" icon={<PrinterOutlined style={{ fontSize: "18px" }} />}>Print</Button>
                    <div className='websiteSysContent'>
                        <div className='contentLogoImgBox'>
                            <img src={jobPostModel.companyLogo ? Config.partnerImg + jobPostModel.companyLogo + '?' + Config.sasToken : CompanyLogo} />
                        </div>
                        <div className='contentTitle'>{jobPostModel.companyName}</div>
                        <div className='flexBox'>
                            <div className='label'>
                                Company Description
                            </div>
                        </div>
                        <div id='companyProfile' className=' valueJustify'>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Office Address</div>
                            <div className='value'>{jobPostModel.companyLocation}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Website</div>
                            <div className='value'>
                                <a href={jobPostModel.companyWebsite && !jobPostModel.companyWebsite.startsWith('https://') ? 'https://' + jobPostModel.companyWebsite : jobPostModel.companyWebsite} target="_blank" rel="noreferrer">{jobPostModel.companyWebsite}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company LinkedIn</div>
                            <div className='value'>
                                <a href={jobPostModel.companySocialMedia && !jobPostModel.companySocialMedia.startsWith('https://') ? 'https://' + jobPostModel.companySocialMedia : jobPostModel.companySocialMedia} target="_blank" rel="noreferrer">{jobPostModel.companySocialMedia}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company YouTube</div>
                            <div className='value'>
                                <a href={jobPostModel.companyYouTube && !jobPostModel.companyYouTube.startsWith('https://') ? 'https://' + jobPostModel.companyYouTube : jobPostModel.companyYouTube} target="_blank" rel="noreferrer">{jobPostModel.companyYouTube}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Instagram</div>
                            <div className='value'>
                                <a href={jobPostModel.companyInstagram && !jobPostModel.companyInstagram.startsWith('https://') ? 'https://' + jobPostModel.companyInstagram : jobPostModel.companyInstagram} target="_blank" rel="noreferrer">{jobPostModel.companyInstagram}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Facebook</div>
                            <div className='value'>
                                <a href={jobPostModel.companyFacebook && !jobPostModel.companyFacebook.startsWith('https://') ? 'https://' + jobPostModel.companyFacebook : jobPostModel.companyFacebook} target="_blank" rel="noreferrer">{jobPostModel.companyFacebook}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company WeChat</div>
                            <div className='value'>
                                {jobPostModel.companyWechat}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Other</div>
                            <div className='value'>
                                {jobPostModel.other}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Description
                            </div>
                        </div>
                        <div id='jobDesc' className=' valueJustify'>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Requirement
                            </div>
                        </div>
                        <div id='jobRequirement' className=' valueJustify'>
                        </div>
                    </div>
                    <div className='line'></div>
                    <div className='websiteSysContent'>
                        <div className='detailPrintButtonBox'>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Job ID</div>
                            <div className='value'>{jobPostModel.jobId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Title
                            </div>
                            <div className='value'>
                                {jobPostModel.jobTitle}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Post Status
                            </div>
                            <div className='value'>
                                {ContextHandler.getMapValue('jobPostStatusMap', jobPostModel.jobPostStatus)}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Post Active Date
                            </div>
                            <div className='value'>
                                {jobPostModel.eventDate ? moment(jobPostModel.eventDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Designated THEi Programme</div>
                            <div className='value'>
                                {/* <div className='stdPositionBox'> */}
                                {jobPostModel.progTitle}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Mode
                            </div>
                            <div className='value'>
                                {jobPostModel.positionTypeVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Employment Type
                            </div>
                            <div className='value'>
                                {jobPostModel.jobTypeVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Salary (HKD)
                            </div>
                            <div className='value'>
                                {jobPostModel.salaryRangeFrom} ~ {jobPostModel.salaryRangeTo}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Salary Basis
                            </div>
                            <div className='value'>
                                {jobPostModel.unitVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Estimated No. of Days a Week
                            </div>
                            <div className='value'>
                                {jobPostModel.estimatedNoOfDaysAWeek}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Estimated No. of Hours a Week
                            </div>
                            <div className='value'>
                                {jobPostModel.estimatedNoOfHoursAWeek}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Work Location
                            </div>
                            <div className='value'>
                                {jobPostModel.workLocVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Expected Commence Date
                            </div>
                            <div className='value'>
                                {jobPostModel.expCommenceDate ? moment(jobPostModel.expCommenceDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Expected End Date
                            </div>
                            <div className='value'>
                                {jobPostModel.expEndDate ? moment(jobPostModel.expEndDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Application Deadline
                            </div>
                            <div className='value'>
                                {jobPostModel.lastApplyDate ? moment(jobPostModel.lastApplyDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="websiteSysButtonBox">
                    {(flag === 'view' || flag === 'apply' || flag === 'assigned') && jobPostModel.lastApplyDate >= moment().startOf('day').valueOf() &&
                        <div className='websiteSysButton' onClick={apply} ><img src={submitApplication} />Apply</div>
                    }
                </div>
                {isStdApplyJobModal && <StdApplyJobModal onClose={stdApplyJobClose} jobPostModel={jobPostModel} />}
            </Spin>
        </div>
    )
}

export default StudentJobDetail;